import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'

import App from './App'

import queryClient from './helpers/queryClient'
import './i18n'
import './helpers/sentry'

import 'react-datepicker/dist/react-datepicker.css'
import '@szhsin/react-menu/dist/index.css'
import '@szhsin/react-menu/dist/transitions/slide.css'

import './index.css'

const AppCmp = (
  <QueryClientProvider client={queryClient}>
    <App />
    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
  </QueryClientProvider>
)

const root = createRoot(document.getElementById('root')!)

root.render(AppCmp)
